import getWithToken from './base/get-with-token'

const getTaxonomyBenchmarkChartData = (id, query) => getWithToken(`/customer-taxonomy/${id}/benchmark-chart-data`)(query)

export default getTaxonomyBenchmarkChartData
